<template>
  <Accordion :error="$v.nfse.services.$error" id="services" title="SERVIÇOS">
    <b-row class="row-padding pb-0">
      <b-col md="4" lg="7">
        <SelectNBS
          :clearable="false"
          :disabled="disabled"
          :error="$v.nfse.services.nbs.$error"
          v-model="nfse.services.nbs"
        />
      </b-col>
      <b-col lg="2">
        <Input label=" " disabled :value="nbsCode" />
      </b-col>
      <b-col lg="3">
        <Input
          label="Cód. tributação"
          labelBold
          :disabled="disabled"
          v-model="nfse.services.cityTaxCode"
          :maxlength="30"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col md="4" lg="3">
        <SelectService :disabled="disabled" v-model="selectedService" />
      </b-col>
      <b-col md="4" lg="2">
        <InputQuantity
          ref="quantity"
          id="quantity"
          label="Quantidade:"
          labelBold
          :disabled="disabled"
          :prefix="false"
          :max="17"
          v-model="selectedService.quantity"
        />
      </b-col>
      <b-col md="4" lg="2">
        <InputMoney
          ref="unitPrice"
          id="unitPrice"
          label="Unitário:"
          labelBold
          :disabled="disabled"
          :max="21"
          v-model="selectedService.price"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputDiscount
          v-model="selectedService.discount"
          :disabled="disabled"
          :disabledChange="!isValidService"
          :type="selectedService.discountType"
          :max="18"
          @changeDiscount="changeDiscount"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          ref="totalPrice"
          id="totalPrice"
          label="Total:"
          labelBold
          disabled
          :value="selectedService.totalPrice"
        />
      </b-col>
      <b-col md="6" lg="1">
        <br />
        <Button
          type="success"
          class="pl-4 pr-4"
          @click="addService()"
          :disabled="!isValidService || addingService"
        >
          <b-spinner small v-if="addingService" />
          <PlusThick v-else class="mr-0" title="Adicionar" />
        </Button>
      </b-col>
    </b-row>
    <div v-if="nfse.services.serviceCollection.length">
      <div class="border-bottom m-2 mt-3 mb-3" />
      <b-row class="form-group table-list-products">
        <b-col>
          <ServiceList
            :disabled="disabled"
            :fields="fields"
            :items="nfse.services.serviceCollection"
            @edit="edit"
            @remove="remove"
          />
        </b-col>
      </b-row>
    </div>
  </Accordion>
</template>

<script>
import { Accordion, SelectService, SelectNBS } from '@/components';
import {
  Button,
  InputMoney,
  InputQuantity,
  Input,
  InputDiscount,
} from '@/components/Form';
import { mapActions, mapState } from 'vuex';
import { CalcTypesNFSeEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import PlusThick from 'vue-material-design-icons/PlusThick';
import DiscountMixin from '@/modules/Fiscal/mixins/DiscountMixin';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import { required } from '@/reusable/validations';
import ServiceList from '../ServiceList.vue';

export default {
  name: 'Services',
  mixins: [FormatMixin, DiscountMixin],
  components: {
    Accordion,
    SelectService,
    Button,
    InputMoney,
    PlusThick,
    Input,
    SelectNBS,
    ServiceList,
    InputQuantity,
    InputDiscount,
  },
  data() {
    return {
      MAX_TOTAL_PRICE: 999999999999.99,
      VALUE: 0,
      PERCENT: 1,
      addingService: false,
      selectedService: [],
      fields: [
        { key: 'description', tdClass: 'col-3 text-center' },
        { key: 'quantity', tdClass: 'col-2 text-center' },
        { key: 'price', tdClass: 'col-2 text-center' },
        { key: 'discount', tdClass: 'col-2 text-center' },
        { key: 'totalPrice', tdClass: 'col-2 text-center' },
        { key: 'actions' },
      ],
    };
  },
  validations: {
    nfse: {
      services: {
        nbs: { required },
        serviceCollection: { required },
      },
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    await this.setEmptyService();
  },
  computed: {
    ...mapState('nfse', ['nfse']),

    nbsCode() {
      return this.nfse.services.nbs?.code ?? null;
    },
    isValidService() {
      return this.selectedService.totalPrice >= 0.01;
    },
  },
  methods: {
    ...mapActions('nfse', [
      'setRemainder',
      'setServiceInCollection',
      'calculateNfse',
    ]),
    ...mapActions('nfseComponents', [
      'toggleModalEditService',
      'setServiceToEdit',
    ]),
    toggleAddingServiceLoader() {
      this.addingService = !this.addingService;
    },
    async setEmptyService() {
      this.selectedService = [];
      this.selectedService.quantity = 1;
    },
    async addService() {
      if (
        this.valorUS(this.selectedService.totalPrice) > this.MAX_TOTAL_PRICE
      ) {
        this.$alert.error(
          'Valor total não pode ser maior que R$ 999.999.999.999,99',
        );
        return;
      }

      this.toggleAddingServiceLoader();

      const service = {
        ...this.selectedService,
        id: undefined,
        remoteServiceId: this.selectedService.id,
      };

      await this.setServiceInCollection(service);
      await this.calculateNfse([
        CalcTypesNFSeEnum.TOTAL_SERVICES,
        CalcTypesNFSeEnum.TAXES_BASED_ON_SERVICES,
        CalcTypesNFSeEnum.DISCOUNT_BASED_ON_SERVICES,
        CalcTypesNFSeEnum.TOTAL_NF,
      ]);

      this.setEmptyService();
      this.setRemainder();
      this.toggleAddingServiceLoader();
    },
    async edit(data) {
      const service = { ...data.item, index: data.index };

      await this.setServiceToEdit(service);

      this.toggleModalEditService();
    },
    async remove(data) {
      this.nfse.services.serviceCollection.splice(data.index, 1);

      await this.calculateNfse([
        CalcTypesNFSeEnum.TOTAL_SERVICES,
        CalcTypesNFSeEnum.TAXES_BASED_ON_SERVICES,
        CalcTypesNFSeEnum.DISCOUNT_BASED_ON_SERVICES,
        CalcTypesNFSeEnum.TOTAL_NF,
      ]);

      this.setRemainder();
    },
    async changeDiscount(data) {
      this.selectedService.discountType = data;

      this.selectedService.totalPrice = this.calculateTotalItem(
        this.selectedService,
      );
    },
  },
  watch: {
    selectedService: {
      handler() {
        if (!this.selectedService) {
          this.setEmptyService();
        }

        this.selectedService.totalPrice = this.calculateTotalItem(
          this.selectedService,
        );
      },
      deep: true,
    },
    'nfse.services.nbs': {
      handler(value) {
        this.nfse.taxes.cityServiceListItem = value;
      },
    },
    'nfse.services.cityTaxCode': {
      handler(value) {
        this.nfse.taxes.cityTaxCode = value;
      },
    },
  },
};
</script>
